import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { fetchTopicList } from './api'
import { connect } from 'react-redux'
import { jumpTo } from '@/utils'
import styles from '@/styles'
import Header from "@/components/Header";
import bridge from '@/config/JSbridge'
import bwmodel from '@/config/bwmodel';
import moment from 'moment';
import { handleUploadTrace } from "@/utils";

const isStorm = bwmodel.app === 'storm';
const isAfterJanuary = moment().isAfter(moment("2025-02-01"));

const Delivery = ({props,userId, token}) => {  
  const [topicList, setTopicList] = useState([]);
  const [isCurrent, setIsCurrent] = useState(true);
 

  useEffect(()=> {
    handleUploadTrace('Million_StocksRanking_Exposure', 'visitor')
    const lastDayOfMonth  = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
    const term = isCurrent ? '' :moment(lastDayOfMonth).format('YYYY-MM')
    const params = {
      "maxCount":999,
      "term": term
    }
    fetchTopicList(params)
      .then(res => {
        console.log(res.content);
        setTopicList(res.content);
      })
  
  },[isCurrent])



  function setCurrent() {
    
    const bool = !isCurrent;
    setIsCurrent(bool);
    // getComplexRankList();
  }
    // 
    const handleLogin = (cb) => {
      if(!isStorm) {
        window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
      }
      bridge.callHandler(
        'nativeEvent',
        {
          event: 'login',
          params: {
            refreshOnBack: true
          }
        },
        () => {}
      );
    }
  

    function goEidt(content) {
      // const str = base64.replace('data:image/png;base64,','');
      // const textOptions = {
      //   1: '#2023年度结#',
      //   2: '2023年我的年投资收益： \n主要盈利来自于： \n主要亏损来自于：\n目前比较看好：\n 2024年，我希望 \n\n#2023年度总结#',
      //   3: '2023年我的全年总收益为“请输入”%，主要以“请输入”投资为主。\n2023年我的投资心得\n说说经验教训：1、\n 2024年，我希望 \n\n#2023年度总结#',
      //   4: '用一句话总结我的2023年就是\n2023年，我在投资上\n2023年，我的生活上\n2024年，新的一年一些打算： \n\n#2023年度总结#'
      // }

    if(!token) {
      return  handleLogin()
    } 
  
    const text = `#${content}#`
      bridge.callHandler('nativeEvent', {
        event: 'openPublishForumEvent',
        params: {
          text: text,
        }
      }, res => {
      })
  }
  // const stockRank = 10;

  return (
    <React.Fragment>
        {isStorm && 
        <Header
          title="本期推荐话题"
          right={
            isAfterJanuary && <div 
              onClick={() => setCurrent()}
            >
              {isCurrent === true ? '上期话题': '本期'} 
            </div>
          }
          hideNaviBar
          bg_color={styles.bg_color2}
        />
      }
      
    <MoodsBox>
      <div className='title'>发布推荐话题创作，前10名瓜分千元现金</div>

      <div className='topic_box'>
        <div className='topic_header'>
          <div>话题名称</div>
          <div>发布入口</div>
        </div>

        {
          topicList.map((item) => {
            return   <div className='topic_item' 
              onClick={()=> {
                goEidt(item.topicName)
              }}
            >
            <div className='topic_item_left' 
              onClick={(event)=>{
                event.stopPropagation();
                jumpTo(`storm://app/topic/detail?name=${item.topicName}`)
              }}>
              <div className='topic_item_title'><span> #&nbsp;{item.topicName} </span></div>
              <div className='desc'>{item.topicDesc}</div>
            </div>
            <div className="topic_item_right">
              去发布
              </div>
          </div>
          })
        }
      </div>
    </MoodsBox>
    </React.Fragment>
  )
}

// export default React.memo(forwardRef(Delivery));
const mapStateToProps = (state) => {
  // console.log(state);
  return {
    token: state.user.accessToken || '',
    userId: state.user.userId
  }
}

export default React.memo(connect(mapStateToProps)(Delivery));
export const MoodsBox = styled.div`
  position: relative;
  background: linear-gradient(0deg, #F7D9B8 0%, #F7D9B8 100%);
  min-height: 100vh;
  padding-top: 64px;
  .title {
    text-align: center;
    font-size: 14px;
  color: #000000;
  }
  .topic_box {
    margin: 12px;
    padding: 14px;
    background-color:#FFF9F3;
    border-radius: 10px;
    // width: 100%;
    // box-sizing: content-box;
  }
    .topic_header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      font-size: 12px;
      color: #000;
    }
   .topic_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    + .topic_item {
      margin-top: 3vw;
    }

    .topic_item_left {
      font-weight: bolder;
      font-size: 19px;
        color: #C63711;
   
       width: calc(100% - 80px);
       flex:1;
       flex-wrap: wrap;

      >span {
        font-bold: bolder;
      }
    }
    .topic_item_title {
      flex: 1;
       white-space: nowrap;        
        overflow: hidden;          
        text-overflow: ellipsis;   
        width: 200px;
    }
    
    .topic_item_right {
      width: 75px;
      height: 30px;
      background: #C63711;
      border-radius: 15px;
      line-height: 30px;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #FFF5EA;
      flex-shrink: 0;
      margin-left: 10px;
    }
    .desc {
      flex-wrap: nowrap; /* 默认值，单行显示 */
      margin-top: 5px;
      font-size: 12px;
      color: #000;
      max-width:100%;
      white-space: nowrap;        /* 禁止文本换行 */
      overflow: hidden;           /* 隐藏超出容器的文本 */
      text-overflow: ellipsis;    /* 使用省略号表示溢出的文本 */
    }
  }
     
`;



// WEBPACK FOOTER //
// ./src/views/activity_130/create.js